import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../user/signup.css';

const Signup = () => {
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    let navigate = useNavigate();

    const submitHandler = (event) => {
        event.preventDefault();
        setIsLoading(true);
        setError('');

        axios.post('https://pkrealestateapi.onrender.com/user/signup', {
            userName: userName,
            password: password,
            email: email,
            phone: phone
        })
        .then(res => {
            console.log(res.data);
            navigate('/login');
        })
        .catch(err => {
            console.log(err);
            setError(err.response?.data?.message || 'An error occurred during signup');
        })
        .finally(() => {
            setIsLoading(false);
        });
    }

    return (
        <div className="signup-wrapper">
            <div className="signup-container">
            <div className="company-title">
                    <h2>P.K Real Estate</h2>
                </div>
                <div className="signup-header">
                    <h1>Create Account</h1>
                    <div className="animated-underline"></div>
                </div>
                
                {error && <div className="error-message">{error}</div>}
                
                <form onSubmit={submitHandler} className="signup-form">
                    <div className="form-group">
                        <input
                            type='text'
                            required
                            className="form-input"
                            onChange={(e) => setUserName(e.target.value)}
                            disabled={isLoading}
                        />
                        <label className="form-label">Username</label>
                        <span className="form-line"></span>
                    </div>

                    <div className="form-group">
                        <input
                            type='password'
                            required
                            className="form-input"
                            onChange={(e) => setPassword(e.target.value)}
                            disabled={isLoading}
                        />
                        <label className="form-label">Password</label>
                        <span className="form-line"></span>
                    </div>

                    <div className="form-group">
                        <input
                            type='email'
                            required
                            className="form-input"
                            autoComplete='off'
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={isLoading}
                        />
                        <label className="form-label">Email</label>
                        <span className="form-line"></span>
                    </div>

                    <div className="form-group">
                        <input
                            type='number'
                            required
                            className="form-input"
                            onChange={(e) => setPhone(e.target.value)}
                            disabled={isLoading}
                        />
                        <label className="form-label">Phone</label>
                        <span className="form-line"></span>
                    </div>

                    <button type='submit' className="submit-btn" disabled={isLoading}>
                        {isLoading ? (
                            <div className="loader-container">
                                <div className="loader"></div>
                                <span>Creating Account...</span>
                            </div>
                        ) : (
                            'Sign Up'
                        )}
                    </button>

                    <div className="login-link">
                        Already have an account? <Link to="/login" className="login-btn">Login</Link>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Signup;